module.exports = __webpack_public_path__ + "img/face7.7af91f95.jpg";